import { Links, Meta, Scripts, ScrollRestoration } from "react-router";
import { ExternalScripts } from "remix-utils/external-scripts";
import type { PropsWithChildren } from "react";

import { cn } from "#app/lib/utils";
import { TooltipProvider } from "#app/components/ui/tooltip";

export type HtmlProps = {
  title?: string;
  env?: Record<string, string | undefined>;
  nonce: string;
};

export function Html({
  children,
  title,
  env = {},
  nonce,
}: PropsWithChildren<HtmlProps>) {
  const theme = "light";

  return (
    <html lang="en" className={cn("h-full", theme)}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
          nonce={nonce}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
          nonce={nonce}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
          nonce={nonce}
        />
        <link rel="manifest" href="/site.webmanifest" nonce={nonce} />

        {title ? <title>{title}</title> : null}

        <Meta />
        <Links />
      </head>
      <body className="h-full">
        <TooltipProvider delayDuration={300}>{children}</TooltipProvider>

        <script
          nonce={nonce}
          dangerouslySetInnerHTML={{
            __html: `window.__PHA_ENV__ = ${JSON.stringify(env)};`,
          }}
        />

        <ExternalScripts />
        <ScrollRestoration nonce={nonce} />
        <Scripts nonce={nonce} />
      </body>
    </html>
  );
}
